module.exports = __webpack_public_path__ + "img/delete-icon.74c86112.svg";